export const MY_APPS_ROUTES = {
  ROOT: '/my-apps',
  BROWSE: '/my-apps',
} as const;
